import { refList } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { ListDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["LIST_QUEUE_URL"]

export const getRefListData = async (
  tx: DbTransaction,
  id: string,
): Promise<ListDoc | undefined> => {
  const [row] = await tx
    .select({
      listCode: refList.listCode,
      listName: refList.listName,
      listDescription: refList.listDescription,
      listCategory: refList.listCategory,
      tableName: refList.tableName,
      fieldUniqueId: refList.fieldUniqueId,
      userConfigurable: refList.userConfigurable,
      createdAt: refList.createdAt,
      createdBy: refList.createdBy,
      updatedAt: refList.updatedAt,
      updatedBy: refList.updatedBy,
    })
    .from(refList)
    .where(eq(refList.listCode, id))

  if (!row) {
    console.error(`RefList with id ${id} not found`)
    return
  }

  const refListDoc: ListDoc = {
    id: row.listCode,
    list_name: row.listName,
    list_description: row.listDescription,
    list_category: row.listCategory,
    table_name: row.tableName,
    field_unique_id: row.fieldUniqueId,
    user_configurable: row.userConfigurable,
    created_at: row.createdAt.getTime(),
    created_by: row.createdBy,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refListDoc,
  })

  return refListDoc
}

export const saveRefListToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefListData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
